import axiosInstance from "shared/axios";
import { EMANDATE_REGISTRATION_APIS ,EMANDATE_STATISTIC_REGISTARION,EMANDATE_STATISTICS_PAYMENTS} from "shared/constants";
import { queryparamBuilder } from "shared/utils";

    export const fetchEmandateList = (selected, search, params) => {
        let uri = EMANDATE_REGISTRATION_APIS.listing;
        if (selected) {
          if(search == undefined){
            uri += `${selected}`
          }
          else{
          uri += `?${selected}=${search}&`;
          }
        } else if (Object.keys(params).length) {
          uri += "?";
        }
        uri += queryparamBuilder(params);
        return axiosInstance.get(`${uri}`);
      };
    
    export const fetchEmandateBankDetails = (loan) => {
    let url = `api/v1/loans/emandate-details?loan_reference_number=${loan?.loan_reference_number}&transaction_reference_number=${loan?.transaction_reference_number}`;
    return axiosInstance.get(url);
    };    

    export const fetchEmandateStatisticsPayment = (formattedDate) =>{
      let url = `${EMANDATE_STATISTICS_PAYMENTS.listing}/${formattedDate}`;
      return axiosInstance.get(url);
    }
    

  export const emadateStatistic = (date) => {
    let url = `${EMANDATE_STATISTIC_REGISTARION.listing}/${date}`;
    return axiosInstance.get(url);
};
